import React, { SyntheticEvent } from "react";
import clsx from "clsx";
import { Form } from "react-bootstrap";
import { useFormContext } from "react-hook-form";

import { FilterColumn } from "types";

import styles from "../filter.module.scss";

type FilterColumnProps = {
	column: FilterColumn;
};

const FilterInput = ({ column }: FilterColumnProps) => {
	const { register } = useFormContext();
	const { name, onBlur, onChange, ref } = register(column.name || "");

	return (
		<Form.Control
			name={name}
			onBlur={(e: SyntheticEvent<any>) => {
				onBlur(e);
			}}
			ref={ref}
			defaultValue={undefined}
			placeholder={column.placeholder}
			className={clsx(styles.column, styles.input)}
			onChange={e => {
				e.target.value = column?.normalize
					? column?.normalize(e.target.value)
					: e.target.value;

				onChange(e);
			}}
		/>
	);
};

export default FilterInput;
